import styled from "styled-components";
import { inputBorderColor, labelColor } from "@app/styles";

type Props = {
  disabled?: boolean;
};

export const ButtonContainer = styled.div`
  display: flex;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
        cursor: not-allowed;
        button{
          background-color:rgb(236 236 236 / 50%);
          pointer-events:none;
          color:${labelColor};
        }
      `;
    }
  }}
`;

export const SubBox = styled.div`
  border: 1.5px solid #00be9a;
  border-radius: 8px;
  background: #f9fcff;
  padding: 10px;
`;

export const DialogFooter = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 2px solid ${inputBorderColor};
  padding: 0 40px;
  box-sizing: border-box;
  &.with-no-border {
    border: none;
  }
  &.alt-height {
    height: 72px;
  }
  button:not(:last-child) {
    margin-right: 8px;
  }
  @media (max-width: 575px){
    padding: 0 24px !important;
  }  
`;

export const ConfirmationContentWrapper = styled.div`
  width: 500px;
  padding: 40px;
  &.w-600 {
    width: 600px;
  }
  @media (max-width: 575px){
    max-width: 100%;
  }
`;

export const ConfirmationContent = styled.div`
display: flex;
.confirmation-content {
  line-height: 1.5;
  margin: 0 0 16px;
}
`